import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function Author() {
  return <section className="py-12 md:py-16 px-4 bg-brand-gray border-t border-white/5" data-id="element-24">
      <div className="max-w-5xl mx-auto" data-id="element-25">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-26">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-27">
            <div className="absolute inset-0 bg-brand-yellow/20 blur-3xl rounded-full" data-id="element-28" />
            <img src="https://cdn.magicpatterns.com/uploads/q1kYU7kyJuHFCDFaRhcTFA/image_(2).webp" alt="Martín Castro, especialista en microcemento" width={384} height={480} loading="lazy" decoding="async" className="relative z-10 w-full max-w-sm mx-auto aspect-[4/5] object-cover rounded-2xl border-2 border-brand-yellow/20" data-id="element-29" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-30">
            <h2 className="text-4xl md:text-6xl text-white mb-8" data-id="element-31">
              CONOCÉ A <span className="text-brand-yellow" data-id="element-32">MARTÍN CASTRO</span>
            </h2>

            <div className="space-y-6 text-lg text-gray-300 font-medium mb-10" data-id="element-33">
              <p data-id="element-34">
                Martín lleva años trabajando en remodelaciones y aplicaciones de
                microcemento.
              </p>
              <p data-id="element-35">
                Después de cometer errores, invertir dinero y aprender en campo
                real, decidió organizar todo el proceso en un sistema simple
                para que cualquier persona pueda aprenderlo.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4" data-id="element-36">
              {[{
              number: '12+',
              label: 'Años de experiencia'
            }, {
              number: '500+',
              label: 'Clientes atendidos'
            }, {
              number: '1.000+',
              label: 'Proyectos realizados'
            }].map((stat, i) => <div key={i} className="text-center p-4 bg-brand-dark rounded-xl border border-white/5" data-id="element-37">
                  <div className="text-2xl md:text-4xl font-display text-brand-yellow mb-2" data-id="element-38">
                    {stat.number}
                  </div>
                  <div className="text-xs md:text-sm text-gray-400 font-bold uppercase tracking-wider" data-id="element-39">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}